import { useEffect, useState } from 'react';
import api from '../../lib/api';
import Button from '../../components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import Input from '../../components/ui/Input';

export default function WebhooksPage() {
  const [subs, setSubs] = useState<any[]>([]);
  const [url, setUrl] = useState('');
  const [events, setEvents] = useState('broadcast.sent');

  const load = async () => {
    const res = await api.get('/webhooks/subscriptions');
    setSubs(res.data);
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <div className="space-y-6 max-w-3xl">
      <h1 className="text-[2.25rem] font-semibold tracking-tightest text-glass-text">Webhooks</h1>
      <p className="text-glass-text-2 text-sm">
        Subscribe to events. Use <code className="bg-glass-3 border border-glass px-1.5 py-0.5 rounded text-accent2">broadcast.sent</code> or{' '}
        <code className="bg-glass-3 border border-glass px-1.5 py-0.5 rounded text-accent2">*</code> for all (demo).
      </p>

      <Card>
        <CardHeader>
          <CardTitle>New subscription</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          <Input placeholder="https://example.com/webhook" value={url} onChange={(e) => setUrl(e.target.value)} />
          <Input placeholder="Events (comma)" value={events} onChange={(e) => setEvents(e.target.value)} />
          <Button
            onClick={async () => {
              const ev = events.split(',').map((s) => s.trim()).filter(Boolean);
              await api.post('/webhooks/subscriptions', { url, events: ev.length ? ev : ['broadcast.sent'] });
              setUrl('');
              load();
            }}
          >
            Add
          </Button>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Subscriptions</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          {subs.map((s) => (
            <div key={s.id} className="border border-glass bg-glass-2 rounded-xl p-3 text-sm">
              <div className="font-mono break-all text-glass-text">{s.url}</div>
              <div className="text-glass-text-2 mt-1">{s.events?.join(', ')}</div>
              <Button
                size="sm"
                variant="outline"
                className="mt-2"
                onClick={async () => {
                  await api.post(`/webhooks/test/${s.id}`);
                  alert('Test delivery queued (check deliveries)');
                }}
              >
                Send test
              </Button>
            </div>
          ))}
        </CardContent>
      </Card>
    </div>
  );
}
